import { useCallback, useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { useApi } from "../../../api"
import { ICargo, INftAsset } from "../../../interfaces"
import { NftHomeBanner } from "./components/NftHomeBanner"
import { NftHomeRecom } from "./components/NftHomeRecom"
import { Numeral } from "../../../components/Numeral"
import { Utils } from "../../../utils"
import { NftTopList } from "../../../components/NFT/NftTopList"
import { SearchBar } from "../../../components/NFT/SearchBar"
import Carousel from 'react-bootstrap/Carousel'
import { NftHomeCreators } from "./components/NftHomeCreators"
import { useProjectCode } from "../../../hooks/useProjectCode"

export const NftHomePage = () => {
  const projectCode = useProjectCode();
  const api = useApi(projectCode)
  const [isMounted, setIsMounted] = useState(false)
  const [nftAssets, setNftAssets] = useState([])
  const navi = useNavigate();
  const fetchNftAssets = useCallback(() => {
    api.getNftAssetsLast(12, (cargo: ICargo) => {
      if (cargo.returnCode === '000000') {
        setNftAssets(cargo.info.filter((asset: INftAsset) => { return asset.status === 'S' || asset.status === 'B' }))
      }
    })
  }, [api])
  useEffect(() => {
    if (!isMounted) {
      fetchNftAssets()
    }
    setIsMounted(true)
  }, [fetchNftAssets, isMounted])
  return (
    <>
      <section>
        <div className="row mx-0">
          {/* <div className="col-12 col-md-6">
              <h3 className="weight-600">發現、收集和出售非凡的 NFT</h3>
              <div className="text-dark" style={{ fontSize: '1.2rem' }}>Star River 是第一個也是最大的 NFT 市場</div>
              <div className="bt-buy py-2 my-5 ms-0 ms-md-4">
                <span className="material-icons mr-3" style={{ verticalAlign: 'text-bottom' }}>search</span>
                <span className="txt-20 weight-600">探索</span>
              </div>
              <div style={{ color: '#9900ea' }}><span className="material-icons weight-600 mr-3" style={{ verticalAlign: 'text-bottom' }}>star</span>認識Star River</div>
              <div className="p-4"></div>
            </div>
            <div className="col-12 col-md-6 media-body">
              <img className="w-100 mb-4" src={require("../../../assets/img/star/service2.png")} alt="" style={{ maxWidth: '500px' }} />
            </div>
            <div id="search"></div> */}
          <div className="col-12 px-0">
            <Carousel>
              <Carousel.Item>
                <img
                  className="d-block w-100"
                  src={require("../../../assets/img/nft/banner1.jpg")}
                  alt="First slide"
                />
              </Carousel.Item>
              <Carousel.Item>
                <img
                  className="d-block w-100"
                  src={require("../../../assets/img/nft/banner2.jpg")}
                  alt="Second slide"
                />
              </Carousel.Item>
            </Carousel>
          </div>
        </div>
      </section>

      <div className="mt-5">
        <SearchBar />
      </div>

      <div className="p-3 p-md-5"></div>
      <div className="txt-24 text-center weight-600 mb-4 mb-md-5">熱門收藏</div>
      <NftHomeBanner />
      <div className="p-3 p-md-5"></div>
      <div className="txt-24 text-center weight-600 mb-4 mb-md-5">交易排行</div>
      <NftTopList number={10} />
      <div className="text-right container">
        <a href="/web/top100">更多</a>
      </div>

      <div className="p-3 p-md-5"></div>
      <div className="txt-24 text-center weight-600 mb-4 mb-md-5">創作者推薦</div>
      <NftHomeCreators />

      <div className="p-3 p-md-5"></div>
      <div className="txt-24 text-center weight-600 mb-4 mb-md-5">精選 NFT</div>
      <NftHomeRecom />

      <div>

        <div className="mx-auto max-w-2xl py-16 px-4 sm:py-24 sm:px-6 lg:max-w-7xl lg:px-8">
          <h2 className="sr-only">Products</h2>

          <div className="grid grid-cols-1 gap-y-10 gap-x-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 xl:gap-x-8">

            {nftAssets.map((nftAsset: INftAsset, index: number) => {
              return (
                <div key={index} className="group cursor-pointer" onClick={() => {
                  navi(`/web/asset/detail/${nftAsset.nftId}`)
                }}>
                  <div className="aspect-w-1 aspect-h-1 w-full overflow-hidden rounded-lg bg-gray-200 xl:aspect-w-7 xl:aspect-h-8">
                    <img src={Utils().normalizeImagePath(nftAsset.image, projectCode)} alt={nftAsset.description} className="h-full w-full object-cover object-center group-hover:opacity-75" />
                  </div>
                  <h3 className="mt-4 text-sm text-gray-700">{nftAsset.name}</h3>
                  <p className="mt-1 text-lg font-medium text-gray-900">$<Numeral value={nftAsset.sellingPrice} /></p>
                </div>
              )
            })}

          </div>
        </div>
      </div>
    </>
  )
}